import React from 'react';

import JourneyBuilderDecisionSplitContainer from './DecisionSplit/JourneyBuilderDecisionSplitContainer';

const JourneyBuilderArea = () => <JourneyBuilderDecisionSplitContainer />;

JourneyBuilderArea.displayName = 'JourneyBuilderArea';

export default JourneyBuilderArea;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/index.js